/* eslint-disable no-restricted-globals */
import { ROUTES_NOT_SHOW_CONFIRM } from '@/constants/routerName';
import { MODULE_NAME } from '@/constants/moduleName';

function views(path) {
  return () => import(`@/views/${path}`).then((m) => m.default || m);
}

// NOTE: Recommend
// const routes = [
//   {
//     path: '',
//     name: 'home',
//     component: views('HomeView.vue'),
//   },
//   {
//     path: '/path',
//     name: 'Path Name',
//     component: () => import("../layouts/NavBarLayout.vue"), // layout: must have <router-view />
//     children: [
//       {
//         path: 'path-children', // url = /path/path-children
//         component: views('YourComponent.vue') // your component
//       }
//     ]
//   },
// ];

const routes = [
  {
    path: '/',
    component: () => import('../layouts/DefaultLayout.vue'),
    meta: {
      name: 'Home',
    },
    children: [
      {
        path: '',
        name: 'Top',
        component: !process.env.VUE_APP_COLLECT_MODE ? views('TopDetail.vue') : views('Top.vue'),
        meta: {
          title: 'C-FIND',
        },
      },
      {
        path: '/top-detail',
        name: 'TopDetail',
        component: views('TopDetail.vue'),
        meta: {
          title: 'C-FIND',
        },
      },
      {
        path: '/forbidden',
        name: 'Forbidden',
        component: views('Forbidden.vue'),
      },
      {
        path: 'home',
        name: 'home',
        meta: {
          permission: MODULE_NAME.MODULE_HOME,
          title: 'ホーム',
        },
        component: views('Home.vue'),
      },
      {
        path: 'login',
        name: 'Login',
        meta: {
          requiresVisitor: false,
          title: 'ログイン',
        },
        component: views('Auth/Login.vue'),
      },
      {
        path: 'forgot-password',
        name: 'Forgot Password',
        component: views('Auth/ForgotPassword.vue'),
        meta: {
          title: 'パスワードをお忘れの方',
        },
      },
      {
        path: 'reset-password/mail/complete',
        name: 'Reset Mail Complete',
        component: views('Auth/SendResetMailComplete.vue'),
        meta: {
          title: 'リセット用のメール送信完了',
        },
      },
      {
        path: 'reset-password/mail/failure',
        name: 'Reset password Failure',
        component: views('Auth/ResetPasswordFailure.vue'),
        meta: {
          title: 'パスワード再設定',
        },
      },
      {
        path: 'reset-password',
        name: 'Reset password',
        component: views('Auth/ResetPassword.vue'),
        meta: {
          title: 'パスワード再設定',
        },
      },
      {
        path: 'reset-password/complete',
        name: 'Reset password Complete',
        component: views('Auth/ResetPasswordComplete.vue'),
        meta: {
          title: 'パスワード再設定完了',
        },
      },
      {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: views('Errors/ErrorPage.vue'),
        meta: {
          title: 'エラー',
        },
      },
      {
        path: '/maintenance',
        name: 'Maintenance',
        component: views('Maintenance.vue'),
        meta: {
          title: 'メンテナンス',
        },
      },
      // {
      //   path: 'reset-password/failure',
      //   name: 'Reset password Failure',
      //   component: views('Auth/ResetPasswordFailure.vue'),
      // },
      // {
      //   path: 'password/edit',
      //   name: 'Edit Password',
      //   component: views('Auth/EditPassword.vue'),
      // },
      {
        path: 'register',
        redirect: '/register/term',
        component: {
          template: '<router-view></router-view>',
        },
        meta: {
          isContinueAction: ROUTES_NOT_SHOW_CONFIRM.REGISTER,
        },
        children: [
          {
            path: 'term',
            name: 'Register term',
            component: views('Register/RegisterTerm.vue'),
            meta: {
              title: '利用規約同意',
            },
          },
          {
            path: 'info',
            name: 'Register info',
            component: views('Register/RegisterInfo.vue'),
            meta: {
              title: '登録情報入力',
            },
          },
          {
            path: 'failure',
            name: 'Register Failure',
            component: views('Register/RegisterFailure.vue'),
          },
          {
            path: 'mfk-failure',
            name: 'Register mfk Failure',
            component: views('Register/RegisterMfkFailure.vue'),
          },
          {
            path: 'info/confirm',
            name: 'Register info confirm',
            component: views('Register/RegisterInfoConfirm.vue'),
            meta: {
              title: '登録情報確認',
            },
          },
          {
            path: 'confirm-mail/send',
            name: 'Register confirm-mail send',
            component: views('Register/RegisterConfirmMailSend.vue'),
            meta: {
              title: '認証メール送信',
            },
          },
          {
            path: 'temporary/complete',
            name: 'Register temporary complete',
            component: views('Register/RegisterTemporaryComplete.vue'),
            meta: {
              title: '仮登録完了',
            },
          },
        ],
      },

      // Bank Account
      // {
      //   path: 'bank-account',
      //   component: () => import('../layouts/NavBarLayout.vue'),
      //   children: [
      //     {
      //       path: '',
      //       redirect: '/bank-account/info',
      //       component: () => import('../layouts/MenuLayout.vue'),
      //       children: [
      //         {
      //           path: 'password/edit',
      //           component: {
      //             template: '<router-view></router-view>',
      //           },
      //           children: [
      //             {
      //               path: '',
      //               name: 'Change Password',
      //               component: () => import('@/views/Auth/EditPassword.vue'),
      //             },
      //           ],
      //         },
      //         {
      //           path: 'bank-account',
      //           component: {
      //             template: '<router-view></router-view>',
      //           },
      //           children: [
      //             {
      //               path: 'info',
      //               name: 'Bank Account Info',
      //               props: true,
      //               component: () => import('@/views/User/components/Bank/ViewBank.vue'),
      //             },
      //             {
      //               path: 'edit',
      //               name: 'Bank Account Edit',
      //               props: true,
      //               component: () => import('@/views/User/components/Bank/FormBank.vue'),
      //             },
      //             {
      //               path: 'edit/confirm',
      //               name: 'Bank Account Confirm',
      //               props: true,
      //               component: () => import('@/views/User/components/Bank/ConfirmBank.vue'),
      //             },
      //           ],
      //         },
      //         {
      //           path: 'user-account',
      //           component: {
      //             template: '<router-view></router-view>',
      //           },
      //           children: [
      //             {
      //               path: 'management',
      //               name: 'User Account',
      //               component: views('SubAccount/Management.vue'),
      //             },
      //             {
      //               path: 'create',
      //               name: 'Create Account',
      //               component: views('SubAccount/Create.vue'),
      //             },
      //             {
      //               path: 'show/:id',
      //               name: 'Show User Account',
      //               component: views('SubAccount/Show.vue'),
      //             },
      //             {
      //               path: 'edit/:id',
      //               name: 'Edit User Account',
      //               component: views('SubAccount/Edit.vue'),
      //             },
      //           ]
      //         },
      //         {
      //           path: 'usage-detail',
      //           component: {
      //             template: '<router-view></router-view>',
      //           },
      //           children: [
      //             {
      //               path: '',
      //               name: 'Usage Detail',
      //               component: () => import('@/views/Auth/EditPassword.vue'),
      //             },
      //           ],
      //         },
      //         {
      //           path: 'rating-detail/view',
      //           component: {
      //             template: '<router-view></router-view>',
      //           },
      //           children: [
      //             {
      //               path: '',
      //               name: 'Rating Detail',
      //               component: () => import('@/views/Auth/EditPassword.vue'),
      //             },
      //           ],
      //         },
      //         {
      //           path: 'monthly-plan',
      //           component: {
      //             template: '<router-view></router-view>',
      //           },
      //           children: [
      //             {
      //               path: '',
      //               name: 'Monthly Plan',
      //               component: () => import('@/views/Auth/EditPassword.vue'),
      //             }
      //           ]
      //         },
      //       ],
      //     },
      //   ],
      // },

      {
        path: 'ratting-setting',
        name: 'Ratting setting',
        component: views('message/ratting-setting.vue'),
      },
      {
        path: 'ratting-setting/confirm',
        name: 'Ratting setting confirm',
        component: views('message/ratting-setting-confirm.vue'),
      },
      {
        path: 'ratting-setting/complete',
        name: 'Ratting setting complete',
        component: views('message/ratting-setting-complete.vue'),
      },
      {
        path: 'successful-bid/confirm',
        name: 'Successful bid confirm',
        component: views('message/successful-bid-confirm.vue'),
      },
      {
        path: 'messages',
        meta: {
          permission: MODULE_NAME.MODULE_MESSAGE,
          title: 'メッセージ',
        },
        component: {
          template: '<router-view></router-view>',
        },
        children: [
          {
            path: '',
            name: 'Message',
            component: views('message/Message.vue'),
          },
          {
            path: ':won_bid_id',
            name: 'Message Detail',
            // eslint-disable-next-line no-restricted-globals
            // eslint-disable-next-line no-confusing-arrow
            component: () =>
              // eslint-disable-next-line implicit-arrow-linebreak
              screen.width < 1080
                ? import('@/views/message/MessageDetail.vue')
                : import('@/views/message/Message.vue'),
          },
        ],
      },
      // {
      //   path: 'ratting-setting',
      //   name: 'Ratting setting',
      //   component: views('message/ratting-setting.vue'),
      // },
      // {
      //   path: 'ratting-setting/confirm',
      //   name: 'Ratting setting confirm',
      //   component: views('message/ratting-setting-confirm.vue'),
      // },
      // {
      //   path: 'ratting-setting/complete',
      //   name: 'Ratting setting complete',
      //   component: views('message/ratting-setting-complete.vue'),
      // },
      // {
      //   path: 'successful-bid/confirm',
      //   name: 'Successful bid confirm',
      //   component: views('message/successful-bid-confirm.vue'),
      // },
      // {
      //   path: 'violation-report',
      //   name: 'Violation report',
      //   meta: {
      //     permission: MODULE_NAME.MODULE_VIOLATION_REPORT,
      //   },
      //   component: views('ViolationReport/violation_report.vue'),
      // },
      // {
      //   path: 'violation-report/confirm',
      //   name: 'Violation report confirm',
      //   meta: {
      //     permission: MODULE_NAME.MODULE_VIOLATION_REPORT,
      //   },
      //   component: views('ViolationReport/violation_report_confirm.vue'),
      // },
      // {
      //   path: 'violation-report/complete',
      //   name: 'Violation report complete',
      //   meta: {
      //     permission: MODULE_NAME.MODULE_VIOLATION_REPORT,
      //   },
      //   component: views('ViolationReport/violation_report_complete.vue'),
      // },
      // {
      //   path: 're-exhibit',
      //   component: () => import('../layouts/NavBarLayout.vue'),
      //   meta: {
      //     isContinueAction: ROUTES_NOT_SHOW_CONFIRM.RE_EXHIBIT,
      //   },
      //   children: [
      //     {
      //       path: ':id',
      //       name: 'Re Exhibit',
      //       component: views('EstateDetailSeller/ReExhibit.vue'),
      //     },
      //     {
      //       path: ':id/confirm',
      //       name: 'ReExhibitConfirm',
      //       component: views('EstateDetailSeller/ReExhibit.vue'),
      //     },
      //   ],
      // },
      // {
      //   path: 're-exhibit/:id/complete',
      //   name: 'Re Exhibit Complete',
      //   component: views('EstateDetailSeller/ReExhibitComplete.vue'),
      // },
      {
        path: 'bidder-info',
        name: 'bidder info',
        meta: {
          permission: MODULE_NAME.MODULE_BIDDER_INFO,
          title: '入札者情報',
        },
        component: views('bidder-info.vue'),
      },

      // seller info
      {
        path: 'seller-infor/:id',
        name: 'seller infor',
        meta: {
          permission: MODULE_NAME.MODULE_SELLER_INFO,
          title: '出品者情報',
        },
        component: views('seller-infor.vue'),
      },
      {
        path: 'bid/common/confirm',
        name: 'Common confirm',
        component: views('EstateInfo/CommomConfirm.vue'),
        meta: {
          title: '一般入札の確認',
        },
      },
      {
        path: 'bid/immediate-decision/confirm',
        name: 'Decision confirm ',
        component: views('EstateInfo/DecisionConfirm.vue'),
        meta: {
          title: '即決入札の確認',
        },
      },
      {
        path: 'bid/one-time-limit/confirm',
        name: 'Limit confirm',
        component: views('EstateInfo/LimitConfirm.vue'),
      },
      {
        path: 'list-bidding',
        name: 'List Bidding',
        meta: {
          permission: MODULE_NAME.MODULE_LIST_BIDING,
        },
        redirect: '/list-bidding/watch-list',
        component: views('ListBidding/ListBidding.vue'),
        children: [
          {
            path: 'watch-list',
            name: 'ListBiddingWatch',
            component: views('ListBidding/ListBidding.vue'),
            meta: {
              title: 'ウォッチリスト',
              name: 'ウォッチリスト',
            },
          },
          {
            path: 'bid-list',
            name: 'ListBiddingBid',
            component: views('ListBidding/ListBidding.vue'),
            meta: {
              title: '入札リスト',
              name: '入札リスト',
            },
          },
          {
            path: 'won-bid-list',
            name: 'ListBiddingWonBid',
            component: views('ListBidding/ListBidding.vue'),
            meta: {
              title: '落札リスト',
              name: '落札リスト',
            },
          },
          {
            path: 'exhibition-list',
            name: 'ListBiddingExhibition',
            component: views('ListBidding/ListBidding.vue'),
            meta: {
              title: '出品リスト',
              name: '出品リスト',
            },
          },
        ],
      },
      {
        path: 'bid/complete',
        name: 'Bid Complete',
        component: views('EstateInfo/BidComplete.vue'),
      },
      {
        path: 'bid/immediate-decision/complete',
        name: 'Bid Immediate Decision Complete',
        component: views('EstateInfo/BidImmediateDecisionComplete.vue'),
      },
      {
        path: '',
        description: 'All path use MainLayout',
        component: () => import('@/layouts/MainLayout.vue'),
        children: [
          {
            path: 'estate-edit',
            component: {
              template: '<router-view></router-view>',
            },
            meta: {
              isContinueAction: ROUTES_NOT_SHOW_CONFIRM.ESTATE_EDIT,
              permission: MODULE_NAME.MODULE_ESTATE_EDIT,
            },
            children: [
              {
                path: ':id',
                name: 'Estate Edit',
                component: views('EstateEdit/EstateEdit.vue'),
                meta: {
                  title: '物件編集',
                  name: '物件編集',
                },
              },
              {
                path: ':id/confirm',
                name: 'Estate Confirm',
                component: views('EstateEdit/EstateEditConfirm.vue'),
                meta: {
                  title: '物件編集確認',
                  name: '物件編集確認',
                },
              },
              {
                path: 'complete',
                name: 'Estate Complete',
                component: views('EstateEdit/EstateEditComplete.vue'),
                meta: {
                  title: '物件編集完了',
                  name: '物件編集完了',
                },
              },
              {
                path: 'violation-report',
                name: 'Violation report',
                meta: {
                  permission: MODULE_NAME.MODULE_ESTATE_INFO,
                  title: '違反申告',
                  name: '違反申告',
                },
                component: views('ViolationReport/violation_report.vue'),
              },
              {
                path: 'violation-report/confirm',
                name: 'Violation report confirm',
                meta: {
                  permission: MODULE_NAME.MODULE_VIOLATION_REPORT,
                  title: '違反申告内容確認',
                  name: '違反申告内容確認',
                },
                component: views('ViolationReport/violation_report_confirm.vue'),
              },
              {
                path: 'violation-report/complete',
                name: 'Violation report complete',
                meta: {
                  permission: MODULE_NAME.MODULE_VIOLATION_REPORT,
                  title: '違反申告完了',
                  name: '違反申告完了',
                },
                component: views('ViolationReport/violation_report_complete.vue'),
              },
            ],
          },

          // FAQ
          {
            path: 'faq',
            component: {
              template: '<router-view></router-view>',
            },
            meta: {
              permission: MODULE_NAME.MODULE_HELP,
            },
            children: [
              {
                path: 'list',
                name: 'FAQ List',
                component: views('Help/FAQList.vue'),
                meta: {
                  title: 'ヘルプ/FAQ',
                  name: 'FAQ',
                },
              },
            ],
          },
          // Search
          {
            path: 'search',
            name: 'Search Page',
            redirect: '/search/by-address',
            component: views('Search/SearchLayout.vue'),
            meta: {
              permission: MODULE_NAME.MODULE_SEARCH,
            },
            children: [
              {
                path: 'result',
                name: 'SearchResult',
                component: views('Search/SearchResult.vue'),
                meta: {
                  title: '検索結果リスト',
                  name: '検索結果リスト',
                },
              },
              {
                path: 'by-address',
                name: 'SearchByAddress',
                component: views('Search/SearchByAddress.vue'),
                meta: {
                  title: '住所から検索',
                  name: '住所から検索',
                },
              },
              {
                path: 'by-train-line',
                component: views('Search/SearchByTrainLineLayout.vue'),
                children: [
                  {
                    path: '',
                    name: 'SearchByTrainLine',
                    component: views('Search/SearchByTrainLine.vue'),
                    meta: {
                      title: '沿線から検索',
                      name: '沿線から検索',
                    },
                  },
                  {
                    path: 'station',
                    name: 'SearchByTrainLineStation',
                    component: views('Search/SearchByTrainLineStation.vue'),
                    meta: {
                      title: '沿線から検索',
                      name: '沿線から検索',
                    },
                  },
                ],
              },
              {
                path: 'mail-register',
                name: 'Mail Register Complete',
                component: views('Search/MailRegisterComplete.vue'),
              },
              {
                path: 'mail-unregister',
                name: 'Mail Unregister Complete',
                component: views('Search/MailUnregisterComplete.vue'),
              },
              {
                path: 'favorite',
                name: 'Search Favorite',
                component: views('Search/SearchFavorite.vue'),
                meta: {
                  title: 'お気に入り検索',
                  name: 'お気に入り検索',
                },
              },
            ],
          },
          {
            path: 'service',
            component: {
              template: '<router-view></router-view>',
            },
            meta: {
              permission: MODULE_NAME.MODULE_TERM_OF_SERVICE,
            },
            children: [
              {
                path: 'operating-company',
                name: 'OperatingCompany',
                component: views('TermOfService/OperatingCompany.vue'),
                meta: {
                  title: '運営会社情報',
                  name: '運営会社情報',
                },
              },
              {
                path: 'privacy-policy',
                name: 'Privacy Policy',
                component: views('TermOfService/PrivacyPolicy.vue'),
                meta: {
                  title: '個人情報保護',
                  name: '個人情報保護',
                },
              },
              {
                path: 'term-of-service',
                name: 'Term Of Service',
                component: views('TermOfService/TermOfService.vue'),
                meta: {
                  title: '利用規約',
                  name: '利用規約',
                },
              },
              {
                path: 'site-map',
                name: 'Site Map',
                component: views('TermOfService/SiteMap.vue'),
                meta: {
                  title: 'サイトマップ',
                  name: 'サイトマップ',
                },
              },
            ],
          },
          {
            path: 'inquiry',
            name: 'Inquiry',
            meta: {
              permission: MODULE_NAME.MODULE_INQUIRY,
              title: 'お問い合わせ',
              name: 'お問い合わせ',
            },
            component: views('Inquiry/Inquiry.vue'),
          },

          {
            path: 'pre-c-find/form/contactus',
            name: 'Other page Link',
            beforeEnter: () => {
              window.location.href = 'https://req.qubo.jp/pre-c-find/form/contactus';
            }
          },

          {
            path: 'riche-partners',
            name: 'Riche Partners',
            beforeEnter: () => {
              window.location.href = 'https://riche-partners.com';
            }
          },

          // Account info
          {
            path: 'account-info',
            name: 'AccountInfo',
            meta: {
              permission: MODULE_NAME.MODULE_ACCOUNT_INFO,
            },
            redirect: '/account-info/basic-info',
            component: () => import('@/layouts/MenuLayout.vue'),
            children: [
              {
                path: '',
                redirect: '/account-info/basic-info',
                component: {
                  template: '<router-view></router-view>',
                },
                children: [
                  {
                    path: 'basic-info',
                    component: {
                      template: '<router-view></router-view>',
                    },
                    meta: {
                      name: '基本情報',
                    },
                    children: [
                      {
                        path: '',
                        name: 'Basic Info',
                        component: () => import('@/views/User/components/Info/ViewInfo.vue'),
                        meta: {
                          title: '基本情報',
                        },
                      },
                      {
                        path: ':token',
                        name: 'Basic info verify',
                        component: () => import('@/views/User/components/Info/ViewInfo.vue'),
                      },
                      {
                        path: 'edit',
                        name: 'Basic Info Edit',
                        component: () => import('@/views/User/components/Info/FormInfo.vue'),
                        meta: {
                          name: '基本情報編集',
                          title: '基本情報編集',
                        },
                      },
                      {
                        path: 'edit/confirm',
                        name: 'Basic Info Edit Confirm',
                        component: () => import('@/views/User/components/Info/FormConfirm.vue'),
                        meta: {
                          name: '基本情報編集確認',
                          title: '基本情報編集確認',
                        },
                      },
                    ],
                  },
                  {
                    path: 'password/edit',
                    name: 'Change Password',
                    component: () => import('@/views/Auth/EditPassword.vue'),
                    meta: {
                      name: 'パスワード変更',
                      title: 'パスワード変更',
                    },
                  },
                  {
                    path: 'user-account/management',
                    component: {
                      template: '<router-view></router-view>',
                    },
                    meta: {
                      name: '担当者アカウント管理',
                    },
                    children: [
                      {
                        path: '',
                        name: 'User Account',
                        component: views('SubAccount/Management.vue'),
                        meta: {
                          title: '担当者アカウント追加',
                        },
                      },
                      {
                        path: 'create',
                        name: 'Create Account',
                        component: views('SubAccount/Create.vue'),
                        meta: {
                          name: '担当者アカウント追加',
                          title: '担当者アカウント追加',
                        },
                      },
                      {
                        path: 'show/:id',
                        name: 'Show User Account',
                        component: views('SubAccount/Show.vue'),
                        meta: {
                          name: '担当者アカウント参照',
                          title: '担当者アカウント参照',
                        },
                      },
                      {
                        path: 'edit/:id',
                        name: 'Edit User Account',
                        component: views('SubAccount/Edit.vue'),
                        meta: {
                          name: '担当者アカウント編集',
                          title: '担当者アカウント編集',
                        },
                      },
                    ],
                  },
                  {
                    path: 'destination-info',
                    component: views('User/components/Bank/UserBank.vue'),
                    meta: {
                      isContinueAction: ROUTES_NOT_SHOW_CONFIRM.DESTINATION,
                      name: '請求先情報',
                    },
                    children: [
                      {
                        path: '',
                        props: true,
                        name: 'Bank Account Info',
                        component: () => import('@/views/User/components/Bank/ViewBank.vue'),
                        meta: {
                          title: '請求先情報',
                        },
                      },
                      {
                        path: ':token',
                        props: true,
                        name: 'Bank account verify',
                        component: () => import('@/views/User/components/Bank/ViewBank.vue'),
                      },
                      {
                        path: 'edit',
                        name: 'Bank Account Edit',
                        props: true,
                        component: () => import('@/views/User/components/Bank/FormBank.vue'),
                        meta: {
                          name: '請求先情報編集',
                          title: '請求先情報編集',
                        },
                      },
                      {
                        path: 'edit/confirm',
                        name: 'Bank Account Confirm',
                        props: true,
                        component: () => import('@/views/User/components/Bank/ConfirmBank.vue'),
                        meta: {
                          name: '請求先情報編集確認',
                          title: '請求先情報編集確認',
                        },
                      },
                    ],
                  },
                  {
                    path: 'usage-detail',
                    component: {
                      template: '<router-view></router-view>',
                    },
                    children: [
                      {
                        path: '',
                        name: 'Usage Detail',
                        component: () => import('@/views/User/UsageDetail.vue'),
                        meta: {
                          name: '利用明細',
                          title: '利用明細',
                        },
                      },
                    ],
                  },
                  {
                    path: 'rating-detail/view',
                    component: {
                      template: '<router-view></router-view>',
                    },
                    meta: {
                      name: '評価詳細確認',
                      title: '評価詳細確認',
                    },
                    children: [
                      {
                        path: '',
                        name: 'Rating Detail',
                        component: views('User/RatingDetail/index.vue'),
                      },
                    ],
                  },
                  {
                    path: 'monthly-plan',
                    name: 'Monthly Plan',
                    component: views('User/MonthlyPlan/index.vue'),
                    meta: {
                      name: '月額プラン情報確認',
                      title: '月額プラン情報確認',
                    },
                  },
                ],
              },
            ],
          },

          // Advertising option
          {
            path: 'advertising-option',
            component: {
              template: '<router-view></router-view>',
            },
            meta: {
              name: '広告オプション',
              permission: MODULE_NAME.MODULE_ADVERTISING_OPTION,
            },
            children: [
              {
                path: '',
                name: 'Advertising Option',
                component: views('AdvertisingOption/AdvertisingOption.vue'),
                meta: {
                  title: '広告オプション利用時',
                },
              },
              {
                path: 'select',
                name: 'Advertising Option Select',
                component: views('AdvertisingOption/AdvertisingOptionSelect.vue'),
                meta: {
                  name: '広告オプション選択',
                  title: '広告オプション選択',
                },
              },
              {
                path: 'frame/select',
                name: 'Advertising Option Frame Select',
                component: views('AdvertisingOption/AdvertisingOptionFrameSelect.vue'),
                meta: {
                  name: '広告枠選択',
                  title: '広告枠選択',
                },
              },
            ],
          },

          // Option
          {
            path: 'option',
            name: 'Option',
            component: views('Option/Option.vue'),
            meta: {
              name: 'オプション',
              title: 'オプション',
              permission: MODULE_NAME.MODULE_OPTION,
            },
          },

          // For router use rocket
          {
            path: '',
            component: () => import('@/layouts/SocketLayout.vue'),
            children: [
              // Estate Info
              {
                path: 'estate-info',
                meta: {
                  permission: MODULE_NAME.MODULE_ESTATE_INFO,
                },
                component: {
                  template: '<router-view></router-view>',
                },
                children: [
                  {
                    path: 'estate-detail/:id',
                    name: 'Estate Detail',
                    component: views('EstateInfo/EstateInfoDetail.vue'),
                    meta: {
                      title: '物件詳細',
                    },
                  },
                  {
                    path: 'bid',
                    meta: {
                      name: '物件詳細',
                    },
                    component: views('EstateInfo/EstateInfoBidLayout.vue'),
                    children: [
                      {
                        path: 'common/confirm',
                        name: 'EstateInfoBidConfirmCommon',
                        component: views('EstateInfo/EstateInfoConfirmCommon.vue'),
                        meta: {
                          name: '物件名',
                          title: '一般入札の確認',
                        },
                      },
                      {
                        path: 'immediate-decision/confirm',
                        name: 'EstateInfoBidConfirmImmediate',
                        component: views('EstateInfo/EstateInfoConfirmImmediate.vue'),
                        meta: {
                          name: '物件名',
                          title: '即決入札の確認',
                        },
                      },
                      {
                        path: 'one-time-limit/confirm',
                        name: 'EstateInfoBidConfirmOnetime',
                        component: views('EstateInfo/EstateInfoConfirmOnetime.vue'),
                        meta: {
                          name: '物件名',
                          title: '1回限定入札の確認',
                        },
                      },
                      {
                        path: 'complete',
                        name: 'EstateInfoBidCompleteCommon',
                        component: views('EstateInfo/EstateInfoCompleteCommon.vue'),
                        meta: {
                          name: '物件名',
                          title: '入札完了',
                        },
                      },
                      {
                        path: 'immediate-decision/complete',
                        name: 'EstateInfoBidCompleteImmediate',
                        component: views('EstateInfo/EstateInfoCompleteImmediate.vue'),
                        meta: {
                          name: '物件名',
                          title: '即決入札完了',
                        },
                      },
                    ],
                  },
                  {
                    path: 'estate-bid-history/:id',
                    name: 'EstateBidHistory',
                    component: views('EstateInfo/EstateBidHistory.vue'),
                    meta: {
                      title: '入札履歴',
                    },
                  },
                ],
              },

              // Estate detail seller
              {
                path: 'estate-detail-seller',
                component: {
                  template: '<router-view></router-view>',
                },
                meta: {
                  permission: MODULE_NAME.MODULE_ESTATE_DETAIL_SELLER,
                  isContinueAction: ROUTES_NOT_SHOW_CONFIRM.RE_EXHIBIT,
                },
                children: [
                  {
                    path: ':id',
                    name: 'EstateDetailSeller',
                    component: views('EstateDetailSeller/EstateDetailSeller.vue'),
                    meta: {
                      title: '物件詳細出品者',
                      name: '物件詳細出品者',
                    },
                  },
                  {
                    path: 're-exhibit/:id',
                    name: 'EstateExhibitSeller',
                    component: views('EstateDetailSeller/ReExhibit.vue'),
                    meta: {
                      title: '再出品',
                      name: '再出品',
                    },
                  },
                  {
                    path: 're-exhibit/:id/confirm',
                    name: 'ReExhibitConfirm',
                    component: views('EstateDetailSeller/re_exhibit_confirm.vue'),
                    meta: {
                      title: '再出品確認',
                      name: '再出品確認',
                    },
                  },
                  {
                    path: 'bid-history/:id',
                    name: 'EstateDetailSellerBidHistory',
                    component: views('EstateDetailSeller/EstateDetailSellerHistory.vue'),
                    meta: {
                      title: '物件詳細出品入札履歴',
                      permission: MODULE_NAME.ESTATE_SELLER,
                    },
                  },
                ],
              },
            ],
          },

          // Create estate
          {
            path: 'estate-create',
            redirect: '/estate-create/term',
            component: views('EstateCreate/EstateCreate.vue'),
            meta: {
              isContinueAction: ROUTES_NOT_SHOW_CONFIRM.ESTATE_CREATE,
              permission: MODULE_NAME.MODULE_ESTATE_CREATE,
            },
            children: [
              {
                path: 'term',
                name: 'EstateCreateTerm',
                component: views('EstateCreate/EstateCreateTerm.vue'),
                meta: {
                  title: '物件登録の利用規約',
                  name: '物件登録の利用規約',
                },
              },
              {
                path: 'category',
                name: 'EstateCategory',
                component: views('EstateCreate/EstateCategory.vue'),
                meta: {
                  title: '物件種目選択',
                  name: '物件種目選択',
                },
              },
              {
                path: 'address',
                name: 'EstateAddress',
                component: views('EstateCreate/EstateAddress.vue'),
                meta: {
                  title: '地域・市区町村選択',
                  name: '地域・市区町村選択',
                },
              },
              {
                path: 'detail-info',
                name: 'EstateDetailInfo',
                component: views('EstateCreate/EstateDetailInfo.vue'),
                meta: {
                  title: '物件の詳細情報',
                  name: '物件の詳細情報',
                },
              },
              {
                path: 'confirm',
                name: 'EstateInfoConfirm',
                component: views('EstateCreate/EstateInfoConfirm.vue'),
                meta: {
                  title: '物件の情報確認',
                  name: '物件の情報確認',
                },
              },
              {
                path: 'complete',
                name: 'EstateCreateComplete',
                component: views('EstateCreate/EstateCreateComplete.vue'),
                meta: {
                  title: '物件登録完了',
                  name: '物件登録完了',
                },
              },
            ],
          },

          {
            path: 'news',
            meta: {
              permission: MODULE_NAME.MODULE_NEWS,
            },
            component: {
              template: '<router-view></router-view>',
            },
            children: [
              {
                path: '',
                name: 'News',
                component: views('News/News.vue'),
                meta: {
                  name: 'ニュース',
                  title: 'お知らせ',
                },
              },
              {
                path: ':id/detail',
                name: 'NewsDetail',
                meta: {
                  permission: MODULE_NAME.MODULE_NEWS,
                  title: 'お知らせ詳細',
                },
                component: views('News/NewsDetail.vue'),
              },
            ],
          },
        ],
      },
      {
        path: 'estate-delete-confirm/:id',
        name: 'Estate Delete Confirm',
        meta: {
          permission: MODULE_NAME.MODULE_ESTATE_DELETE,
          title: '出品取り消し確認',
        },
        component: views('EstateDelete/EstateDeleteConfirm.vue'),
      },
      {
        path: 'estate-delete-complete',
        name: 'Estate Delete Complete',
        meta: {
          permission: MODULE_NAME.MODULE_ESTATE_DELETE,
          title: '出品取り消し完了',
        },
        component: views('EstateDelete/EstateDeleteComplete.vue'),
      },
      {
        path: 'error-page/:id',
        name: 'Error Page',
        meta: {
          permission: MODULE_NAME.MODULE_ERRORS,
        },
        component: views('Errors/ErrorPage.vue'),
      },
      {
        path: 'estate-delete-confirm/:id',
        name: 'Estate Delete Confirm',
        meta: {
          permission: MODULE_NAME.MODULE_ESTATE_DELETE,
        },
        component: views('EstateDelete/EstateDeleteConfirm.vue'),
      },
      {
        path: 'estate-delete-complete',
        name: 'Estate Delete Complete',
        meta: {
          permission: MODULE_NAME.MODULE_ESTATE_DELETE,
        },
        component: views('EstateDelete/EstateDeleteComplete.vue'),
      },
      {
        path: 'error-page/:id',
        name: 'Error Page',
        component: views('Errors/ErrorPage.vue'),
      },
      {
        path: 'verify/forgot-password',
        name: 'Verify Forgot Password',
        component: views('Auth/VerifyForgotPassword.vue'),
        meta: {
          title: 'パスワードをお忘れの方',
        },
      },
      {
        path: 'verify/register',
        name: 'Verify Register',
        component: views('Register/VerifyRegister.vue'),
      },
      {
        path: '403',
        component: views('Search/SearchLayout.vue'),
        children: [
          {
            path: '',
            name: '403',
            component: views('Errors/403.vue'),
            meta: {
              title: 'エラー',
            },
          },
        ],
      },
      {
        path: 'verify-error',
        component: views('Search/SearchLayout.vue'),
        children: [
          {
            path: '',
            name: 'verify-error',
            component: views('Errors/ErrorVerifyEmail.vue'),
          },
        ],
      },
    ],
  },
];

export default routes;
